// extracted by mini-css-extract-plugin
export var pillWrapper = "_mc-0";
export var showOverflow = "_mc-1";